const isListColumnVisible = (userSettings, listId, assemblerItem) => {
	if (!userSettings || !listId || !userSettings.lists || !userSettings.lists[listId] || !userSettings.lists[listId].columns ||
		!assemblerItem.name || userSettings.lists[listId].columns[assemblerItem.name] === undefined) {
		// can be undefined
		return assemblerItem.default !== false;
	}

	return userSettings.lists[listId].columns[assemblerItem.name];
};

export default isListColumnVisible;
